import { appSync, setToken, startListening } from '@bonanza-social/toolkit/state';
import {
  fetchPrizeWall,
  fetchPrizeWallReward,
  selectPrizeWallDataState,
  setLockedRewardId,
} from './prizeWall.slice';
import { prefetchImages, prefetchLocalImages } from '../../utils/images';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch, getState }) => {
    const dataState = selectPrizeWallDataState(getState());

    if (dataState === 'fulfilled' || dataState === 'rejected') {
      dispatch(fetchPrizeWall());
    }
  },
});

startListening({
  actionCreator: fetchPrizeWall.fulfilled,
  effect: ({ payload }) => {
    prefetchImages([
      payload.backgroundImage,
      payload.headerImage,
      ...payload.quickRules.map((rule) => rule.image),
    ]);
    prefetchLocalImages();
  },
});

startListening({
  actionCreator: fetchPrizeWallReward.fulfilled,
  effect: ({ payload }, { dispatch }) => {
    const { isWin, rewardId, tokenBalance } = payload;

    dispatch(setToken({ balance: tokenBalance }));

    if (isWin && rewardId !== undefined) {
      dispatch(setLockedRewardId(rewardId));
    }
  },
});
